/**
 * GAPS-4 (2026-10-18) — a SWITCHED pause is not idle or pause time.
 *
 * `switch_my_work` (W5, 20270206071000) pauses vehicle A with pause_intent 'SWITCHED' and starts / resumes vehicle B
 * in the same transaction. While A is switched away the technician is hands-on on B, and that time is already in the
 * wrenching minutes (B's ticket_timer_sessions). Counting A's SWITCHED pause as pause time as well subtracted the same
 * minutes twice from the available minutes, so idle time was understated by the length of every switch.
 * Every other pause intent (ADVISOR, TECH_HELP, PARTS, BLOCKED, BREAK, OTHER, legacy NULL) is unchanged.
 */
export const SWITCHED_PAUSE_INTENT = 'SWITCHED';

export function isSwitchedAwayPause(p: { pause_intent?: string | null }): boolean {
  return p.pause_intent === SWITCHED_PAUSE_INTENT;
}
